import { ThemeProvider } from "emotion-theming"
import React from "react"
import { Global, css } from "@emotion/core"
import { Flex } from "rebass"
import Navbar from "./Navbar"
import theme from "../theme"
import Footer from "./Footer"
import SEO from "./SEO"
import "../app.scss"

export default function Layout({ children, seo }) {
  return (
    <ThemeProvider theme={theme}>
      <Global
        styles={css`
          body {
            margin: 0;
            background: ${theme.colors.mainBackground};
          }
        `}
      />
      <SEO {...seo} />
      <Navbar />
      <Flex
        bg="mainBackground"
        flexDirection="column"
        sx={{ paddingX: [0, 6], marginTop: "160px" }}
      >
        {children}
        <Footer />
      </Flex>
    </ThemeProvider>
  )
}
